// extracted by mini-css-extract-plugin
export var autoExpand = "_36-b";
export var container = "_36-a";
export var containerWidth = "_36-8";
export var disabled = "_36-2";
export var error = "_36-3";
export var fullWidth = "_36-9";
export var highlightContainer = "_36-5";
export var inputWrapper = "_36-0";
export var small = "_36-1";
export var textarea = "_36-4";
export var validatedTextarea = "_36-6";
export var visuallyHidden = "_36-7";